import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import NewsLetter from '../HomePage/NewsLetter'
import Footer from '../HomePage/Footer'
import ContactPage from './ContactPage'
import Location from './Location'

function GetInTouchIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <ContactPage />
      <Location />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default GetInTouchIndex
